import { render } from "./MarketCheck.vue?vue&type=template&id=fa126c62"
import script from "./MarketCheck.vue?vue&type=script&lang=js"
export * from "./MarketCheck.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\msimi\\Downloads\\KIM\\pvmi-coaching-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__